<template>
  <van-popup
    v-model="showPopup"
    round
    position="bottom"
    :style="{ height: '45%' }"
    closeable
  >
    <div class="wrap">
      <QRCode :url="url" ref="qr"></QRCode>
      <!-- <div id="qrcode" ref="qrCodeUrl"></div> -->
      <div class="title">暂存成功，邀请朋友扫描二维码</div>
      <van-row :gutter="20">
        <van-col :span="12">
          <van-button type="default" block @click="showPopup = false"
            >取消</van-button
          >
        </van-col>
        <van-col :span="12">
          <van-button type="info" block @click="handleInvitePerson"
            >邀请同行人员</van-button
          >
        </van-col>
      </van-row>
    </div>
  </van-popup>
</template>

<script>
import QRCode from './qrcode'
import { init } from '@/utils/wxSDK'
import qs from 'qs'
export default {
  props: ['url'],
  data() {
    return {
      showPopup: false,
    }
  },
  methods: {
    handleInvitePerson() {
      this.$toast('点击右上角按钮，分享给朋友')
    },
  },
  computed: {
    id() {
      return qs.parse(this.url).visitorid
    },
  },
  created() {},
  watch: {
    showPopup(val) {
      if (val && this.id) {
        console.log('打开分享获取到的url', this.url, this.id)
        init({
          title: `邀请您预约`,
          description: '来一起预约',
          imgUrl:
            'https://img2.woyaogexing.com/2020/08/05/1730990ea10a48c0b4583e1a5bb4b383!400x400.jpeg',
          url: `https://ai-prod.asiait.net/inviteAddPeer?schoolId=${this.$store.state.schoolId}&visitorId=${this.id}`,
        })
      }
    },
  },

  components: {
    QRCode,
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  padding: 30px 20px;
  text-align: center;
  .title {
    padding: 20px;
  }
  #qrcode {
    display: inline-block;
    /* border: 1px solid #999; */
  }
}
</style>
